import React from "react";
import { Row, Col, Button, Form, Checkbox, Steps } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import "./Application6.css";
import "../components/StepsTracker.css";

const Application6: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const handleNext = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Form values:", values);
        // Navigate to next step (Future Communications)
        navigate("/application7");
      })
      .catch((errorInfo) => {
        console.log("Validation failed:", errorInfo);
      });
  };

  return (
    <div className="application-step-container">
      <div className="application-title-card">
        <div className="title-card-content">
          <div className="city-name-title">City of New Orleans, Louisiana</div>
          <h1 className="program-title-main">E-Bike Incentive Application</h1>
        </div>
      </div>

      <div className="progress-tracker-container">
        <Steps
          current={5}
          className="progress-tracker-steps"
          items={[
            { title: "Review Eligibility" },
            { title: "Confirm Details" },
            { title: "Personal Information" },
            { title: "Upload Documents" },
            { title: "Income Verification" },
            { title: "Survey" },
            { title: "Future Communications" },
            { title: "Terms & Conditions" },
          ]}
        />
      </div>

      <div className="main-step-card">
        <div className="step-header-container">
          <div className="step-badge">
            <div className="step-label">STEP</div>
            <div className="step-number">6</div>
          </div>
          <div className="step-content-info">
            <h2 className="step-title">Survey</h2>
            <p className="step-description">
              Please answer a few questions to help us improve this program in
              the future.
            </p>
          </div>
        </div>

        <div className="step-divider" />

        <div className="survey-section">
          <Form form={form} layout="vertical" className="survey-form">
            {/* Question 1 */}
            <div className="question-section">
              <h3 className="question-title">
                1. How did you hear about this e-bike program?
              </h3>
              <Form.Item name="hearAboutProgram" className="checkbox-form-item">
                <Checkbox.Group className="checkbox-group">
                  <Row gutter={[0, 4]}>
                    <Col span={24}>
                      <Checkbox
                        value="community-organization"
                        className="survey-checkbox"
                      >
                        Community Organization
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="bike-shop" className="survey-checkbox">
                        Bike Shop
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="poster" className="survey-checkbox">
                        Poster
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox
                        value="flyer-community-event"
                        className="survey-checkbox"
                      >
                        Flyer at Community Event
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox
                        value="through-friend"
                        className="survey-checkbox"
                      >
                        Through a Friend
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox
                        value="online-social-media"
                        className="survey-checkbox"
                      >
                        Online/Social Media
                      </Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </div>

            {/* Question 2 */}
            <div className="question-section">
              <h3 className="question-title">
                2. Which category below includes your age?
              </h3>
              <Form.Item name="ageCategory" className="checkbox-form-item">
                <Checkbox.Group className="checkbox-group">
                  <Row gutter={[0, 4]}>
                    <Col span={24}>
                      <Checkbox
                        value="17-or-younger"
                        className="survey-checkbox"
                      >
                        17 years old or younger
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="18-25" className="survey-checkbox">
                        18 - 25 years old
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="26-35" className="survey-checkbox">
                        26 - 35 years old
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="36-55" className="survey-checkbox">
                        36 - 55 years old
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="56-or-older" className="survey-checkbox">
                        56 years old or older
                      </Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </div>

            {/* Question 3 */}
            <div className="question-section">
              <h3 className="question-title">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In
                bibendum erat justo, at?
              </h3>
              <Form.Item name="question3" className="checkbox-form-item">
                <Checkbox.Group className="checkbox-group">
                  <Row gutter={[0, 4]}>
                    <Col span={24}>
                      <Checkbox value="option1" className="survey-checkbox">
                        sa sit amet, vehicula porttitor elit amet o
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="option2" className="survey-checkbox">
                        at est, t consectetur augue, imperdietincidunt
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="option3" className="survey-checkbox">
                        hendrerit at nibh. Vivamus vulputa
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="option4" className="survey-checkbox">
                        t consectetur augue, imperdie
                      </Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </div>

            {/* Question 4 */}
            <div className="question-section">
              <h3 className="question-title">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In
                bibendum erat justo, at?
              </h3>
              <Form.Item name="question4" className="checkbox-form-item">
                <Checkbox.Group className="checkbox-group">
                  <Row gutter={[0, 4]}>
                    <Col span={24}>
                      <Checkbox value="option1" className="survey-checkbox">
                        sa sit amet, vehicula porttitor elit amet o
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="option2" className="survey-checkbox">
                        at est, t consectetur augue, imperdietincidunt
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="option3" className="survey-checkbox">
                        hendrerit at nibh. Vivamus vulputa
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="option4" className="survey-checkbox">
                        t consectetur augue, imperdie
                      </Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </div>

            {/* Question 5 */}
            <div className="question-section">
              <h3 className="question-title">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In
                bibendum erat justo, at?
              </h3>
              <Form.Item name="question5" className="checkbox-form-item">
                <Checkbox.Group className="checkbox-group">
                  <Row gutter={[0, 4]}>
                    <Col span={24}>
                      <Checkbox value="option1" className="survey-checkbox">
                        sa sit amet, vehicula porttitor elit amet o
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="option2" className="survey-checkbox">
                        at est, t consectetur augue, imperdietincidunt
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="option3" className="survey-checkbox">
                        hendrerit at nibh. Vivamus vulputa
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="option4" className="survey-checkbox">
                        t consectetur augue, imperdie
                      </Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>

      <div className="navigation-buttons">
        <Link to="/application5">
          <Button
            type="default"
            icon={<ArrowLeftOutlined />}
            className="back-button"
          >
            Back
          </Button>
        </Link>
        <Button
          type="primary"
          className="next-button"
          size="large"
          onClick={handleNext}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default Application6;
